module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/zh-hant/5-c7e1c462af210050cc87e91967a3db25.jpg";